function getViewedProducts() {
  try {
    return JSON.parse(sessionStorage.getItem("viewedProducts")) || [];
  } catch {
    return [];
  }
}
function saveViewedProducts(handles) {
  sessionStorage.setItem("viewedProducts", JSON.stringify(handles));
}
function trackProductView(handle) {
  if (!handle) return;
  const viewed = getViewedProducts().filter((h) => h !== handle);
  viewed.push(handle);
  if (viewed.length > 9) viewed.shift();
  saveViewedProducts(viewed);
}
function removeViewedProduct(handle) {
  if (!handle) return;
  saveViewedProducts(getViewedProducts().filter((h) => h !== handle));
}
function getViewedProductHandles(excludeHandle) {
  return getViewedProducts().filter((h) => h !== excludeHandle).reverse();
}
export {
  getViewedProductHandles as g,
  removeViewedProduct as r,
  trackProductView as t
};
